import React, { useState } from "react";
import styles from "../../Application.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../../stores/common";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";

function VapeAttestation({ vapeAttestationData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(768);

  const data = vapeAttestationData?.data || {};

  const renderSection = (title, items) => (
    <div className={styles.info_section}>
      {title && (
        <>
          <div className={styles.section_title}><h5>{title}</h5></div>
          <div className={styles.desktop_heading}><HeadingWithLine text={title} /></div>
        </>
      )}
      <div className={styles.info_grid}>
        {items.map((item, i) => (
          <div key={i} className={styles.info_item}>
            <span className={styles.label}>{item.label}</span>
            <span className={styles.value}>{item.value || "-"}</span>
          </div>
        ))}
      </div>
      <ul className={styles.desktop_list}>
        {items.map((item, i) => (
          <li key={i}>
            <div>
              <p>{item.label}</p>
              <p>{item.value || "-"}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  const productTypeNames = (data.vape_attestation_product_types || [])
    .map((p) => p?.name)
    .filter(Boolean)
    .join(", ");

  const ageVerificationValue =
    data.vape_attestation_method_of_age_verification === "Other"
      ? data.vape_attestation_other_method_of_age_verification
      : data.vape_attestation_method_of_age_verification;

  return (
    <div
      className={`${isMobile ? styles.mobile_business_info : styles.business_information} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div
        className={isMobile ? styles.business_info_header : styles.head}
        onClick={() => setExpanded((v) => !v)}
      >
        {isMobile ? (
          <>
            <CaretRight24 className={`${styles.caret_icon} ${expanded ? styles.expanded : ""}`} />
            <h4>Vape Attestation</h4>
          </>
        ) : (
          <>
            <ButtonIcon>
              <CaretRight24 className={expanded ? styles.expanded : ""} />
            </ButtonIcon>
            <h5>Vape Attestation</h5>
          </>
        )}
      </div>

      <div
        className={`${isMobile ? styles.mobile_content : styles.body} ${expanded ? (isMobile ? styles.expanded : styles.body_expanded) : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expanded && (
          <>
            {renderSection(null, [
              { label: "Source of marketing", value: data.vape_attestation_what_is_your_source_of_marketing },
              { label: "Audience", value: data.vape_attestation_what_audience_is_the_product_marketed_to },
            ])}
            {renderSection("Top 5 selling products", [
              { label: "Product 1", value: data.vape_attestation_product_1 },
              { label: "Product 2", value: data.vape_attestation_product_2 },
              { label: "Product 3", value: data.vape_attestation_product_3 },
              { label: "Product 4", value: data.vape_attestation_product_4 },
              { label: "Product 5", value: data.vape_attestation_product_5 },
            ])}
            {renderSection("Where are the products manufactured?", [
              { label: "Name, address, Phone number", value: data.where_are_the_products_manufactured },
            ])}
            {renderSection("Product Types", [
              { label: "Product Types", value: productTypeNames },
            ])}
            {renderSection("Age Verification", [
              { label: "Method", value: ageVerificationValue },
            ])}
          </>
        )}
      </div>
    </div>
  );
}

export default VapeAttestation;
